import { REGIE } from '@/configuration/societe/societe';

export default function setAFacturerAndFournisseurIfRegie(devisCommande) {
  if (devisCommande.role !== REGIE) return;

  devisCommande.lignesCommande.forEach((ligneCommande) => {
    if (!ligneCommande.lignesCommande) return;
    ligneCommande.lignesCommande.forEach((ligneCommande) => {
      ligneCommande.aFacturer = true;
      ligneCommande.fournisseurId = null;
    });
  });
}
